import {
  SET_LANGUAGE,
  LOAD_LANGUAGE_STRINGS_REQUEST,
  LOAD_LANGUAGE_STRINGS_SUCCESS,
  LOAD_LANGUAGE_STRINGS_ERROR
} from '../actions/index';

// default states
// TODO: create one flat list of strings that includes fast lookup (if needed), as opposed to all the
// separate strings sections like parts, accessories, etc.
const stringsState = {
  usingLanguage: 'EN',
  loadedStrings: {},
  getString: () => '',
  isFetching: false,
  error: false,
  languageSelection: {
    DE: 'Deutsch',
    EN: 'English',
    ES: 'Español',
  }
};

export const getString = (selectedStrings, tag, hint = 'general') => {
  let string;
  if (hint.indexOf('monitor') === 0) {
    string = selectedStrings.monitors[tag];
  } else if (hint.indexOf('filter') === 0) {
    string = selectedStrings.filters[tag];
  } else if (hint.indexOf('accessor') === 0) {
    string = selectedStrings.accessories[tag];
  } else if (hint.indexOf('general') === 0) {
    string = selectedStrings.general[tag];
  } else if (hint.indexOf('part') === 0) {
    // TODO hint should be part-description or part-label so we can just pass part number as tag
    string = selectedStrings.parts[tag];
  }
  if (!string) {
    string = selectedStrings.monitors[tag]
      || selectedStrings.parts[tag]
      || selectedStrings.filters[tag]
      || selectedStrings.accessories[tag]
      || selectedStrings.general[tag];
  }
  return string;
};

// reducers
function strings(state = stringsState, action) {
  const { loadedStrings, languageCode, error } = action;
  switch (action.type) {
    case SET_LANGUAGE:
      return {
        ...state,
        usingLanguage: languageCode,
        getString: state.loadedStrings && state.loadedStrings[languageCode] ? (tag, hint) => getString(state.loadedStrings[languageCode], tag, hint) : () => ''
      };
    case LOAD_LANGUAGE_STRINGS_REQUEST:
      return {
        ...state,
        isFetching: true
      };
    case LOAD_LANGUAGE_STRINGS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        loadedStrings: {
          ...state.loadedStrings,
          [languageCode]: loadedStrings
        },
        getString: state.loadedStrings ? (tag, hint) => getString(loadedStrings, tag, hint) : () => ''
      };
    case LOAD_LANGUAGE_STRINGS_ERROR:
      return {
        ...state,
        isFetching: false,
        error
      };
    default:
      return state;
  }
}

export default strings;
